module.exports = __webpack_public_path__ + "static/img/5-3.75b85cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/5-3.png
// module id = aj7Z
// module chunks = 0